import React from 'react';

const PageStateContext = React.createContext();

class PageStateContextProvider extends React.Component {
    state = {};

    render() {
        const { pageState } = this.state;

        const setPageState = (pageState) => this.setState({ pageState });

        return (
            <PageStateContext.Provider value={{ pageState, setPageState }}>
                {this.props.children}
            </PageStateContext.Provider>
        );
    }
}

export { PageStateContext };

export default PageStateContextProvider;
